export const errorToText = (error) => {
  const errorString = error.split("_").join(" ")
  return (
    errorString.charAt(0).toUpperCase() + errorString.slice(1).toLowerCase()
  )
}
